import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Checkbox,
  Chip,
  Typography,
} from "@mui/material";

export default function SideList({
  riskScenariosData = [],
  selectedIndex = 0,
  onSelect = () => {},
  checkedIndices = new Set(),
  onToggleCheck = () => {},
  allowSelection = true,
  showSelectionCheckbox = true,
}) {
  return (
    <Paper
      sx={{
        maxHeight: 650,
        overflowY: "auto",
        backgroundColor: "transparent",
        boxShadow: "none",
        border: "none",
      }}
    >
      <List
        sx={{
          p: 0.5,
          display: "flex",
          flexDirection: "column",
          gap: 0.75,
        }}
      >
        {riskScenariosData.map((scenario, index) => (
          <ListItem key={scenario.id || index} disablePadding>
            <ListItemButton
              selected={selectedIndex === index}
              onClick={() => onSelect(index)}
              sx={{
                alignItems: "flex-start",
                px: 1.5,
                py: 1.25,
                border: "1px solid #d9dee8",
                borderRadius: 1.5,
                backgroundColor: "#ffffff",
                "&.Mui-selected": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  borderColor: "#b9c3d6",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.06)",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.02)",
                },
              }}
            >
              {showSelectionCheckbox && (
                <Checkbox
                  checked={checkedIndices.has(index)}
                  disabled={!allowSelection}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => allowSelection && onToggleCheck(index)}
                  sx={{ mr: 1, mt: 0.1 }}
                />
              )}
              <ListItemText
                primary={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "0.95rem",
                        fontWeight: selectedIndex === index ? 600 : 400,
                      }}
                    >
                      {scenario.title}
                    </Typography>
                    {scenario.recommended && (
                      <Chip
                        label="Recommended"
                        color="success"
                        size="small"
                        variant={selectedIndex === index ? "filled" : "outlined"}
                        sx={{ fontWeight: 600 }}
                      />
                    )}
                  </Box>
                }
                primaryTypographyProps={{
                  component: "div",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
